export default "__VITE_PUBLIC_ASSET__28342d3f__"